import { render } from "./FarmDetail.vue?vue&type=template&id=9b47b97c&scoped=true"
import script from "./FarmDetail.vue?vue&type=script&lang=js"
export * from "./FarmDetail.vue?vue&type=script&lang=js"

import "./FarmDetail.vue?vue&type=style&index=0&id=9b47b97c&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b47b97c"]])

export default __exports__